import { inject, injectable } from 'inversify';

import { User } from '@project44/ui-utils';

import { TenantUnifiedRolesQueryUseCase } from '../../domain/abstract';
import { TenantServiceClientAdapter } from '../../infrastructure/adapters/TenantServiceClientAdapter';

@injectable()
export class TenantUnifiedRolesQuery extends TenantUnifiedRolesQueryUseCase {
  constructor(
    @inject(TenantServiceClientAdapter)
    private readonly tenantServiceClientAdapter: TenantServiceClientAdapter,
  ) {
    super();
  }

  public readonly execute: TenantUnifiedRolesQueryUseCase['execute'] = async (
    user: User,
    payload,
  ) => {
    this.validateUseCase(user);

    const { result } =
      await this.tenantServiceClientAdapter.getTenantUnifiedRoles({
        tenantDto: payload.tenant,
      });

    return {
      tenantUnifiedRoles: result,
    };
  };
}
